var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnarchive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 17 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#404347",
  d: "M4.5 4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5M4.5 6a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#404347",
  fillRule: "evenodd",
  d: "M.5 9.52a1 1 0 0 1 .01-.123L1.972.627A.75.75 0 0 1 2.712 0h11.576a.75.75 0 0 1 .74.627l1.462 8.77a1 1 0 0 1 .01.124v5.729a.75.75 0 0 1-.75.75H1.25a.75.75 0 0 1-.75-.75zM1.59 9l1.334-8h11.152l1.334 8h-3.733a.677.677 0 0 0-.677.676A2.324 2.324 0 0 1 8.676 12h-.352A2.324 2.324 0 0 1 6 9.676.676.676 0 0 0 5.324 9zm13.91 1v5h-14v-5h3.516a3.324 3.324 0 0 0 3.308 3h.352a3.324 3.324 0 0 0 3.309-3z",
  clipRule: "evenodd"
})));
export default SvgUnarchive;